import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Container } from './styles';

const DateRangePicker = ({ startDate, setStartDate, endDate, setEndDate, onComplete }) => {

  const [range, setRange] = useState([startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      onComplete();
    }
  }, [startDate, endDate, onComplete]);

  const handleChange = (dates) => {
    const [start, end] = dates;
    setRange([start, end]);
    setStartDate(start);
    setEndDate(end);
  };

    return (
      <Container>
        <DatePicker
          selected={range[0]}
          open={true}
          onChange={handleChange}
          startDate={range[0]}
          endDate={range[1]}
          selectsRange
          portalId="root-portal"
          popperPlacement="top-end"
        />
      </Container>
    );
  };
  
  export default DateRangePicker;